<template>
  <div>
    <white-section-portfolio
    :id="dataPort[0].id"
    :alt-port="dataPort[0].title" 
    :image-port="require(`@/assets/img/portfolio/${dataPort[0].imageFull}`)"
    :link-port="dataPort[0].link"
    :visible-port="dataPort[0].linkVisible"
    :title-port="dataPort[0].title"
    :subtitle-port="dataPort[0].desc">
    </white-section-portfolio>
    <blue-section-portfolio
    :id="dataPort[1].id"
    :alt-port="dataPort[1].title"
    :image-port="require(`@/assets/img/portfolio/${dataPort[1].imageFull}`)"
    :link-port="dataPort[1].link"
    :visible-port="dataPort[1].linkVisible"
    :title-port="dataPort[1].title"
    :subtitle-port="dataPort[1].desc">
    </blue-section-portfolio>
    <white-section-portfolio 
    :id="dataPort[2].id"
    :alt-port="dataPort[2].title" 
    :image-port="require(`@/assets/img/portfolio/${dataPort[2].imageFull}`)"
    :link-port="dataPort[2].link"
    :visible-port="dataPort[2].linkVisible"
    :title-port="dataPort[2].title"
    :subtitle-port="dataPort[2].desc">
    </white-section-portfolio>
    <blue-section-portfolio
    :id="dataPort[3].id" 
    :alt-port="dataPort[3].title"
    :image-port="require(`@/assets/img/portfolio/${dataPort[3].imageFull}`)"
    :link-port="dataPort[3].link"
    :visible-port="dataPort[3].linkVisible"
    :title-port="dataPort[3].title"
    :subtitle-port="dataPort[3].desc">
    </blue-section-portfolio>
    <white-section-portfolio
    :id="dataPort[4].id"
    :alt-port="dataPort[4].title"
    :image-port="require(`@/assets/img/portfolio/${dataPort[4].imageFull}`)"
    :link-port="dataPort[4].link"
    :visible-port="dataPort[4].linkVisible"
    :title-port="dataPort[4].title"
    :subtitle-port="dataPort[4].desc">
    </white-section-portfolio>
    <blue-section-portfolio
    :id="dataPort[5].id"
    :alt-port="dataPort[5].title"
    :image-port="require(`@/assets/img/portfolio/${dataPort[5].imageFull}`)"
    :link-port="dataPort[5].link"
    :visible-port="dataPort[5].linkVisible"
    :title-port="dataPort[5].title"
    :subtitle-port="dataPort[5].desc">
    </blue-section-portfolio>
    <small-section-portfolio></small-section-portfolio>
  </div>
</template>

<script>
export default {
    computed: {
        dataPort() {
            return this.$store.state.loadedPortfolio
        }
    }
}
</script>
